import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAlerts } from '@api/data-security';

export const getCoreDataSecurityAlertsSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAlerts',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAlerts,
	retainDataOnRequest: true
});
